import React, { Component } from "react";
import { Link } from "react-router";

import "./style.scss";

export default class SignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      artistPricing: 528,
    };
  }

  switchArtist = () => {
    switch (this.state.artistPricing) {
      case 49:
        this.setState({ artistPricing: 528 });
        break;
      case 528:
        this.setState({ artistPricing: 49 });
        break;
      default:
        return;
    }
  };

  render() {
    const { abossPackage, selectArtistPricing } = this.props;
    const { artistPricing } = this.state;

    return (
      <section className="aboss__signup">
        {abossPackage === "artist" && (
          <h1>Select your {abossPackage} license</h1>
        )}
        {abossPackage === "agency" && (
          <h1 className="aboss__signup-agency">
            Select your {abossPackage} license
          </h1>
        )}

        {abossPackage === "artist" && (
          <div className="aboss__signup-systems-container wide">
            <div className="aboss__signup-systems-container-item">
              <div className="aboss__signup-systems-artist">
                <h2>{artistPricing === 528 ? "Yearly" : "Monthly"}</h2>
                <h1>ABOSS Artist</h1>

                <div className="aboss__signup-switch">
                  <span>Yearly</span>
                  <input
                    type="checkbox"
                    onClick={this.switchArtist}
                    id="switchArtist"
                  />
                  <span>Monthly</span>
                </div>

                <ul>
                  <li>Manage your calendar with events, notes & blocks</li>
                  <li>Give access to your team with detailed permissions</li>
                  <li>Label and filter all your events how you'd like</li>
                  <li>Request the availability of crew members</li>
                  <li>Keep track of your current cashflow</li>
                </ul>

                {artistPricing === 49 && (
                  <div className="aboss__signup-systems-pricing">
                    <span>
                      <span>&euro;</span>
                      <span>39</span>
                      <span>/ month</span>
                    </span>
                  </div>
                )}
                {artistPricing === 528 && (
                  <div className="aboss__signup-systems-pricing">
                    <span>
                      <span>&euro;</span>
                      <span>399</span>
                      <span>/ year</span>
                    </span>
                  </div>
                )}

                <div className="aboss__signup-systems-buttons">
                  <a href="#artist">
                    <button onClick={() => selectArtistPricing(artistPricing)}>
                      Select
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        )}

        {abossPackage === "agency" && (
          <div className="aboss__signup-systems-container wide">
            <div className="aboss__signup-systems-container-item animated">
              <div className="aboss__signup-systems-agency small">
                <h2>1 - 10 Calendars</h2>
                <h1>Small</h1>

                <ul>
                  <li>
                    <strong>Book shows & manage up to 10 calendars</strong>
                  </li>
                  <li>Free Support</li>
                  <li>All modules available</li>
                  <li>Import of data optional</li>
                  <li>Unlimited users</li>
                </ul>

                <div className="aboss__signup-systems-pricing">
                  <span>
                    <span>&euro;</span>
                    <span>131</span>
                    <span>/ month</span>
                  </span>
                </div>

                <div className="aboss__signup-systems-buttons">
                  {/* <a href="#agency-small"><button onClick={() => selectArtistPricing(1188)}>Select Small</button></a> */}
                  <Link to="/sign-up/agency#small">
                    <button>Select Small</button>
                  </Link>
                </div>
              </div>
            </div>
            <div className="aboss__signup-systems-container-item animated">
              <div className="aboss__signup-systems-agency medium">
                <h2>11 - 30 Calendars</h2>
                <h1>Medium</h1>

                <ul>
                  <li>
                    <strong>Book shows & manage up to 30 calendars</strong>
                  </li>
                  <li>Free Support</li>
                  <li>All modules available</li>
                  <li>Import of data optional</li>
                  <li>Unlimited users</li>
                </ul>

                <div className="aboss__signup-systems-pricing">
                  <span>
                    <span>&euro;</span>
                    <span>288</span>
                    <span>/ month</span>
                  </span>
                </div>

                <div className="aboss__signup-systems-buttons">
                  <Link to="/sign-up/agency#medium">
                    <button>Select Medium</button>
                  </Link>
                </div>
              </div>
            </div>
            <div className="aboss__signup-systems-container-item animated">
              <div className="aboss__signup-systems-agency large">
                <h2>Unlimited Calendars</h2>
                <h1>Large</h1>

                <ul>
                  <li>
                    <strong>Book shows & manage unlimited calendars</strong>
                  </li>
                  <li>Free Support</li>
                  <li>All modules available</li>
                  <li>Import of data optional</li>
                  <li>Unlimited users</li>
                </ul>

                <div className="aboss__signup-systems-pricing">
                  <span>
                    <span>&euro;</span>
                    <span>522</span>
                    <span>/ month</span>
                  </span>
                </div>

                <div className="aboss__signup-systems-buttons">
                  <Link to="/sign-up/agency#large">
                    <button>Select Large</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// src/views/sign-up/step_2.js